"use strict";const e=require("styled-components").css`
    &.FeatureCard {
        background: ${({theme:e})=>e.colors.common.light};
        align-items: center;
        display: grid;
        grid-column-gap: 10px;
        grid-template-columns: 48px auto 32px;
        border: 1px solid ${({theme:e})=>e.colors.grey[300]};
        padding: ${({theme:e})=>e.spacing.small};
        border-radius: 2px;
        width: 100%;
        cursor: pointer;

        .FeatureCard-label {
            text-align: left;
        }

        .FeatureCard-icon {
            width: 100%;
            height: 48px;

            svg {
                height: 100%;
            }
        }
    }
`;module.exports=e;
//# sourceMappingURL=styles.js.map
